const e = {
  postV1Register: {
    schema: {
      method: "post",
      url: "/v1/register",
      mediaType: "application/json"
    }
  },
  putV1ProfilesOwnerid: {
    schema: {
      method: "put",
      url: "/v1/profiles/{ownerId}",
      mediaType: "application/json"
    }
  },
  patchV1ProfilesOwnerid: {
    schema: {
      method: "patch",
      url: "/v1/profiles/{ownerId}",
      mediaType: "application/json"
    }
  },
  getV1Segments: {
    schema: {
      method: "get",
      url: "/v1/segments"
    }
  }
};
export {
  e as v1Service
};
